import Button from '../components/Button'
import React from 'react';
import styles from '../styles/greatness.module.scss'

function Greatness(props) {
    return (
       <div className={styles.greatness}>
            <p className={styles.title}>Let's step into greatness together.</p>
            <div className={styles.buttons}>
                <div className={styles.c_button}>
                    <Button href={'https://member.empowerofyou.com/checkout/?add-to-cart=4741'} backgroundColor={'#FFBE76'} label={'MONTHLY $5.99'} fontSize={'18px'} />
                    <p>workouts <span className={styles.blue}>|</span> meditations <span className={styles.blue}>|</span> challenges</p>
                </div>
                <div className={styles.c_button}>
                    <Button href={'https://member.empowerofyou.com/checkout/?add-to-cart=353'} backgroundColor={'#9FE5E3'} label={'YEARLY $65.89'} fontSize={'18px'} />
                    <p>workouts <span className={styles.blue}>|</span> meditations <span className={styles.blue}>|</span> challenges</p>
                </div>
            </div>
       </div>
    )
}
  
export default Greatness